/** Base URL for the Ledger app (dashboard-ledger). Login and app usage happen there. */
export const APP_URL = import.meta.env.VITE_APP_URL

export const APP_LOGIN_URL = `${APP_URL}/login`
